module.exports = __webpack_public_path__ + "img/society2.992b9251.jpg";